export const INIT = 'app/FormsPage/INIT';
export const INIT_SUCCESS = 'app/FormsPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/FormsPage/INIT_FAILED';
